export * from './restaurar.component';